import { takeLatest, put, select, call, delay } from 'redux-saga/effects'
import { actions, types } from '@store/ducks/address'
import { actions as gymActions } from '@store/ducks/gym'
import { autocompleAddress, locateAddress } from '@client/services/address'
import { setAppLoading, setAppUpdated } from '@store/ducks/application'

function* updatePredictionSagas({ address }) {
  yield delay(500)
  try {
    const { language } = yield select(state => state.application)
    const sessiontoken = yield select(state => state.address.sessiontoken)

    const defaultParams = { language }

    const params = sessiontoken
      ? { ...defaultParams, sessiontoken }
      : defaultParams

    const { data: result } = yield call(autocompleAddress, address, params)

    yield put(
      actions.updatePredictionsSuccess(result.predictions, result.sessiontoken)
    )
    // eslint-disable-next-line no-empty
  } catch (error) {}
}

function* getAddressLocationSagas({ address }) {
  yield put(setAppLoading)
  try {
    const { data: result } = yield call(locateAddress, address)
    yield put(actions.getAddressLocationSuccess())
    yield put(gymActions.addGymSearchGeolocationFilterRequest(result.position))
    yield put(gymActions.gymSearchRequest())
  } catch (error) {
    yield put(setAppUpdated)
  }
}

export default function*() {
  yield takeLatest(types.UPDATE_PREDICTIONS_REQUEST, updatePredictionSagas)
  yield takeLatest(types.GET_ADDRESS_LOCATION_REQUEST, getAddressLocationSagas)
}
